<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true" class="req-wrapper">
  <nf-grid-wrapper-header-left>
    <h2 class="title">Requests</h2>
  </nf-grid-wrapper-header-left>

  <ng-grid-wrapper-header-right
    class="accounts-label header-size"
    *ngIf="lastRefreshed"
  >
    <small>Last refreshed {{ getTimeAgo() }}</small>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      class="ml-1"
      nf-icon-button="secondary"
      ngbTooltip="Reload Table"
      icon="refresh"
      (click)="refreshRequestPage()"
      container="body"
      placement="bottom-right"
    >
      Reload Table
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      class="ml-1"
      nf-icon-button="secondary"
      ngbTooltip="Help"
      icon="help"
      (click)="openHelpModal()"
      container="body"
      placement="bottom-right"
    ></button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <nf-table-layout
      style="height: 100%"
      [gridOptions]="gridOptions"
      [data]="data"
      [autoResizeGrid]="false"
      *nfLoader="isLoading"
      hideTitle
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
